// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-editor-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.template-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.template-editor-header h1 {
  margin: 0;
  color: #333;
}

.template-editor-content {
  display: flex;
  gap: 20px;
}

.template-form-container {
  flex: 1 1;
  min-width: 0;
}

.template-form {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  resize: vertical;
  min-height: 150px;
  font-family: monospace;
}

.content-help, .form-help {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
}

.content-help p, .form-help p {
  margin-top: 0;
  margin-bottom: 10px;
  color: #555;
}

.content-help ul {
  margin: 0;
  padding-left: 20px;
}

.content-help li {
  margin-bottom: 5px;
}

.content-help code {
  background-color: #e9ecef;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

.form-help {
  margin-top: 8px;
  border-left: 3px solid #3498db;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.btn-primary {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.btn-primary:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #333;
  border: 1px solid #ddd;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

.btn-secondary:disabled {
  color: #95a5a6;
  cursor: not-allowed;
}

.template-preview-container {
  flex: 1 1;
  min-width: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.preview-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #777;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.preview-content {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.preview-subject {
  margin-bottom: 15px;
  padding-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.preview-divider {
  height: 1px;
  background-color: #eee;
  margin: 15px 0;
}

.preview-body {
  font-size: 14px;
  line-height: 1.6;
}

.email-preview {
  color: #333;
}

.sms-preview {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #3498db;
  font-family: sans-serif;
}

.sms-content {
  white-space: pre-line;
}

.loading {
  text-align: center;
  padding: 30px;
  color: #666;
  font-style: italic;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  border-left: 4px solid #c62828;
}

/* Responsive design */
@media (max-width: 768px) {
  .template-editor-content {
    flex-direction: column;
  }
  
  .template-preview-container {
    margin-top: 20px;
    max-height: 500px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".template-editor-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.template-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.template-editor-header h1 {\n  margin: 0;\n  color: #333;\n}\n\n.template-editor-content {\n  display: flex;\n  gap: 20px;\n}\n\n.template-form-container {\n  flex: 1;\n  min-width: 0;\n}\n\n.template-form {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: bold;\n  color: #333;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 150px;\n  font-family: monospace;\n}\n\n.content-help, .form-help {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.content-help p, .form-help p {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #555;\n}\n\n.content-help ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.content-help li {\n  margin-bottom: 5px;\n}\n\n.content-help code {\n  background-color: #e9ecef;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: monospace;\n}\n\n.form-help {\n  margin-top: 8px;\n  border-left: 3px solid #3498db;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.btn-primary {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #2980b9;\n}\n\n.btn-primary:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background-color: #f8f9fa;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #e9ecef;\n}\n\n.btn-secondary:disabled {\n  color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.template-preview-container {\n  flex: 1;\n  min-width: 0;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #eee;\n}\n\n.preview-header h2 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.btn-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #777;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.preview-content {\n  padding: 20px;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.preview-subject {\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n  font-size: 16px;\n  color: #333;\n}\n\n.preview-divider {\n  height: 1px;\n  background-color: #eee;\n  margin: 15px 0;\n}\n\n.preview-body {\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.email-preview {\n  color: #333;\n}\n\n.sms-preview {\n  background-color: #f5f5f5;\n  padding: 15px;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n  font-family: sans-serif;\n}\n\n.sms-content {\n  white-space: pre-line;\n}\n\n.loading {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n  font-style: italic;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border-left: 4px solid #c62828;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .template-editor-content {\n    flex-direction: column;\n  }\n  \n  .template-preview-container {\n    margin-top: 20px;\n    max-height: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
